import React from "react";
import { JitsiMeeting } from "@jitsi/react-sdk";

const JitsiPlayer = ({ ...props }) => {
  return <JitsiMeeting domain="meet.jit.si" {...props} />;
};

export default JitsiPlayer;
